import { APIClient } from "./axiosClient";

const api = new APIClient();
const path = "/geo";

const addressApi = {
  getGEOByAddress(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },
};

export default addressApi;
